import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@ui-kitten/components'
import { SelectIconButtonGroup } from './SelectIconButtonGroup'

export const PaymentMethodsSelect = React.memo(function PaymentMethodsSelect(props) {
  const { t } = useTranslation()
  const filteredMethods = React.useMemo(() => {
    return props.paymentMethods?.filter(item => item.activeInStore?.[props.store]) || []
  }, [props.paymentMethods, props.store])

  if (filteredMethods.length === 0) {
    return (
      <Text status='warning' style={props.style}>
        ⚠️ {t('newSale.noPaymentMethodsForStore')}
      </Text>
    )
  }

  return (
    <SelectIconButtonGroup
      items={filteredMethods}
      selectedItem={props.paymentMethod}
      onItemSelect={props.setPaymentMethod}
      style={props.style}
      disabled={props.disabled}
    />
  )
}, function(prev, next) {
  if (prev.paymentMethod?.id !== next.paymentMethod?.id) {
    return false
  }
  if (prev.purchaseMethods == null) {
    return false
  }
  if (prev.store !== next.store) {
    return false
  }
  return true
})
